import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import imageCompression from "browser-image-compression";

import { createAccountTransporteur, getDepartements, getRegions } from '../../lib/apis'
import { CircleCheck, CirclePlus, Loader2 } from 'lucide-react'
import { TransporteurInterface } from '../../lib/Interfaces/Producteur.interface'
import { toast } from 'react-toastify';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import i18n from '../../i18n';
import { scrollToTop } from '../../lib/utils';
interface ValidationResult {
    isValid: boolean;
    errors: Partial<Record<keyof TransporteurInterface, string>>;
}
function Add_transporteur() {
    const { t } = useTranslation()
    const [regions, setRegions] = useState([])
    const [regions2, setRegions2] = useState([])
    const [loading, setLoading] = useState(false)
    const currentDate = new Date()
    const fileInputRef = useRef<any>(null);
    const fileInputRef2 = useRef<any>(null);
    const fileInputRef3 = useRef<any>(null);
    const fileInputRef4 = useRef<any>(null);
    const fileInputRef5 = useRef<any>(null);
    const fileInputRef6 = useRef<any>(null);
    const fileInputRef7 = useRef<any>(null);
    const [base64Image, setBase64Image] = useState<string[]>(["", "", "", "", "", "", ""]);
    const [departements, setDepartements] = useState([])
    const [departements2, setDepartements2] = useState([])
    const [load, setLoad] = useState(false)
    const [imgCar, setImgCar] = useState<string[]>([])
    const [errors, setErrors] = useState<ValidationResult['errors']>()
    const navigate = useNavigate()
    const [transporteur, setTransporteur] = useState<TransporteurInterface>({
        nom_complet: "",
        phone_number: "",
        region: "",
        departement: "",
        city: "",
        address: "",
        experience: "",
        zones_couvertures: [],
        numero_cni: "",
        documents_base64: [],
        images_base64: [],
        vehicle_name: "",
        vehicle_model: "",
        vehicle_condition: "",
        vehicle_description: "",
        numero_immatriculation: "",
        vehicle_images_base64: [],
        vehicle_papers_base64: [],
    })
    const [step, setStep] = useState(1)
    const [arrondissements, setArrondissements] = useState([])
    const [zones_couvertures, setZones_couvertures] = useState<String[]>([])
    const [arrondissements2, setArrondissements2] = useState([])

    useEffect(() => {
        scrollToTop()
    }, [])

    const [zones, setZone] = useState([
        {
            id: currentDate.getTime(),
            region_id: "",
            departement_id: "",
            arrondissement_id: "",
            region: "",
            departement: "",
            arrondissement: ""
        }
    ])
    const handleButtonClick = (index: number) => {
        if (index === 0) {
            if (fileInputRef.current) {
                fileInputRef.current.click();
            }
            return
        }
        if (index === 1) {
            if (fileInputRef2.current) {
                fileInputRef2.current.click();
            }
            return
        }
        if (index === 2) {
            if (fileInputRef3.current) {
                fileInputRef3.current.click();
            }
            return
        }
        if (index === 3) {
            if (fileInputRef4.current) {
                fileInputRef4.current.click();
            }
            return
        }
        if (index === 4) {
            if (fileInputRef5.current) {
                fileInputRef5.current.click();
            }
            return
        }
        if (index === 5) {
            if (fileInputRef6.current) {
                fileInputRef6.current.click();
            }
            return
        }
        if (index === 6) {
            if (fileInputRef7.current) {
                fileInputRef7.current.click();
            }
            return
        }

    };
    const handleChangeTransporteur = (key: keyof TransporteurInterface, e: any) => {
        setTransporteur({
            ...transporteur,
            [key]: e.target.value
        })
    }
    // const [categories, setCategories] = useState([])
    // const [loader, setLoader] = useState(false)

    const newZone = () => {
        const date = new Date()
        setZone([...zones, {
            id: date.getTime(),
            region_id: "",
            departement_id: "",
            arrondissement_id: "",
            departement: "",
            region: "",
            arrondissement: ""
        }])
    }

    // const newVehicule = () => {
    //     const date = new Date()
    //     setVehicules([...vehicules, {
    //         id: date.getTime(),
    //         vehicle_images_base64: [],
    //         vehicle_name: "",
    //         vehicle_model: "",
    //         vehicle_condition: "",
    //         numero_immatriculation: "",
    //         vehicle_description: "",
    //         vehicle_papers_base64: []
    //     }])
    // }

    const handleChange = (id: number, event: any, val: string) => {
        const { name } = event.target
        console.log("name", name, "value", val)
        setZone((prev) =>
            prev.map((zone) =>
                zone.id === id
                    ? {
                        ...zone,
                        [name]: val
                    } :
                    zone
            )
        )
    }
    // const handleChangeStep2 = (id: number, event: any) => {
    //     const { name, value } = event.target
    //     if (name === "vehicle_images_base64") {
    //         setVehicules((prev) =>
    //             prev.map((vehicule) =>
    //                 vehicule.id === id
    //                     ? {
    //                         ...vehicule,
    //                         [name]: handleImageCar(event)
    //                     } :
    //                     vehicule
    //             )
    //         )
    //         return
    //     }
    //     if (name === "vehicle_papers_base64") {
    //         setVehicules((prev) =>
    //             prev.map((vehicule) =>
    //                 vehicule.id === id
    //                     ? {
    //                         ...vehicule,
    //                         [name]: [base64Image[5], base64Image[6]]
    //                     } :
    //                     vehicule
    //             )
    //         )
    //     }
    //     setVehicules((prev) =>
    //         prev.map((vehicule) =>
    //             vehicule.id === id
    //                 ? {
    //                     ...vehicule,
    //                     [name]: value
    //                 } :
    //                 vehicule
    //         )
    //     )
    // }


    // console.log(base64Image)

    const updatRegions = async () => {
        setLoading(true)
        try {
            const { data } = await axios.get(`${getRegions}`)
            // console.log(data)
            setRegions(data.regions)
            setRegions2(data.regions)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)

        }
    }
    useEffect(() => {
        updatRegions()
    }, [])
    const handleRegionChange = async (id: number) => {
        try {
            const { data } = await axios.get(`${getRegions}/${id}/departements`)
            setDepartements(data.departements)
        } catch (error) {
            console.log(error)
        }
    }
    const handleDepartmentChange = async (id: number) => {
        try {
            const { data } = await axios.get(`${getDepartements}/${id}/arrondissements`)
            setArrondissements(data.arrondissements)
        } catch (error) {
            console.log(error)
        }
    }
    const handleRegionChange2 = async (id: number) => {
        try {
            const { data } = await axios.get(`${getRegions}/${id}/departements`)
            setDepartements2(data.departements)
        } catch (error) {
            console.log(error)
        }
    }
    const handleDepartmentChange2 = async (id: number) => {
        try {
            const { data } = await axios.get(`${getDepartements}/${id}/arrondissements`)
            setArrondissements2(data.arrondissements)
        } catch (error) {
            console.log(error)
        }
    }
    const handleFileChange = async (index: number, e: any) => {
        // console.log(index)
        const file = e.target.files[0];
        if (!file) return;

        try {
            const options = {
                maxSizeMB: 0.01,         // taille max en mégaoctets
                maxWidthOrHeight: 400,  // dimension max en px
                useWebWorker: true,
            };

            const compressedFile = await imageCompression(file, options);

            const base64 = await imageCompression.getDataUrlFromFile(compressedFile);
            const tmpBase = [...base64Image]
            tmpBase[index] = base64
            setBase64Image([...tmpBase]);
        } catch (error) {
            console.error("Erreur de compression :", error);
        }
    };
    const handleImageCar = async (e: any) => {
        // console.log(index)
        if (imgCar.length >= 4) {
            toast.error("Vous ne pouvez pas ajouter plus de 4 images pour le véhicule.")
            return
        }
        const file = e.target.files[0];
        if (!file) return;

        try {
            const options = {
                maxSizeMB: 0.5,         // taille max en mégaoctets
                maxWidthOrHeight: 800,  // dimension max en px
                useWebWorker: true,
            };

            const compressedFile = await imageCompression(file, options);

            const base64 = await imageCompression.getDataUrlFromFile(compressedFile);
            const tmpBase = [...imgCar]
            tmpBase.push(base64)
            setImgCar([...tmpBase]);
        } catch (error) {
            console.error("Erreur de compression :", error);
        }
    };
    function validateUserData1(data: TransporteurInterface): ValidationResult {
        const errors: ValidationResult['errors'] = {};
        let isValid = true;
        data.documents_base64 = base64Image
        data.zones_couvertures = zones
        console.log(zones)
        // Validation du nom complet
        if (!data.nom_complet || data.nom_complet.trim().length === 0) {
            errors.nom_complet = "error_nom";
            isValid = false;
        } else if (data.nom_complet.length < 3) {
            errors.nom_complet = "error_taille_name";
            isValid = false;
        }

        // Validation du numéro de téléphone
        const phoneRegex = /^(?:(?:\+|00)221|0)?[67]\d{8}$/; // Format pour numéros sénégalais
        if (!data.phone_number) {
            errors.phone_number = "error_phone";
            isValid = false;
        } else if (!phoneRegex.test(data.phone_number)) {
            errors.phone_number = "error_taille_phone";
            isValid = false;
        }

        // Validation de la région
        if (!data.region || data.region.trim().length === 0) {
            errors.region = "error_region";
            isValid = false;
        }

        // Validation du département
        if (!data.departement || data.departement.trim().length === 0) {
            errors.departement = "error_departement";
            isValid = false;
        }

        // Validation de la ville
        if (!data.city || data.city.trim().length === 0) {
            errors.city = "error_city";
            isValid = false;
        }

        // Validation de l'adresse
        if (!data.address || data.address.trim().length === 0) {
            errors.address = "error_address";
            isValid = false;
        } else if (data.address.length < 5) {
            errors.address = "error_taille_address";
            isValid = false;
        }

        // Validation de l'experience
        if (!data.experience || data.experience.trim().length === 0) {
            errors.experience = "error_experience";
            isValid = false;
        }

        if (data.zones_couvertures[0].region.trim() === "" || data.zones_couvertures[0].departement.trim() === "") {
            errors.zones_couvertures = "error_zone";
            isValid = false;
        }
        // Validation du numéro de CNI
        // if (!data.numero_cni) {
        //     errors.numero_cni = "error_cni";
        //     isValid = false;
        // } else if (data.numero_cni.length < 9) {
        //     errors.numero_cni = "error_taille_cni";
        //     isValid = false;
        // }

        // Validation des documents
        // if (data.documents_base64[0] === "" || data.documents_base64[1] === "") {
        //     errors.documents_base64 = "error_document";
        //     isValid = false;
        // } else if (data.documents_base64.length > 5) {
        //     errors.documents_base64 = "error_taille_documenet";
        //     isValid = false;
        // }



        return {
            isValid,
            errors
        };
    }
    function validateUserData2(data: TransporteurInterface): ValidationResult {
        const errors: ValidationResult['errors'] = {};
        let isValid = true;
        data.documents_base64 = [base64Image[0], base64Image[1], base64Image[2], base64Image[3]]
        data.zones_couvertures = zones
        data.vehicle_papers_base64 = [base64Image[5], base64Image[6]]
        data.vehicle_images_base64 = imgCar
        console.log(data.documents_base64[0].trim() === "")
        // Validation du nom complet
        if (!data.nom_complet || data.nom_complet.trim().length === 0) {
            errors.nom_complet = "error_nom";
            isValid = false;
        } else if (data.nom_complet.length < 3) {
            errors.nom_complet = "error_taille_name";
            isValid = false;
        }

        // Validation du numéro de téléphone
        const phoneRegex = /^(?:(?:\+|00)221|0)?[67]\d{8}$/; // Format pour numéros sénégalais
        if (!data.phone_number) {
            errors.phone_number = "error_phone";
            isValid = false;
        } else if (!phoneRegex.test(data.phone_number)) {
            errors.phone_number = "error_taille_phone";
            isValid = false;
        }

        // Validation de la région
        if (!data.region || data.region.trim().length === 0) {
            errors.region = "error_region";
            isValid = false;
        }

        // Validation du département
        if (!data.departement || data.departement.trim().length === 0) {
            errors.departement = "error_departement";
            isValid = false;
        }

        // Validation de la ville
        if (!data.city || data.city.trim().length === 0) {
            errors.city = "error_city";
            isValid = false;
        }

        // Validation de l'adresse
        if (!data.address || data.address.trim().length === 0) {
            errors.address = "error_address";
            isValid = false;
        } else if (data.address.length < 5) {
            errors.address = "error_taille_address";
            isValid = false;
        }

        // Validation de l'experience
        if (!data.experience || data.experience.trim().length === 0) {
            errors.experience = "error_experience";
            isValid = false;
        }

        if (data.zones_couvertures[0].region.trim() === "" || data.zones_couvertures[0].departement.trim() === "") {
            errors.zones_couvertures = "error_zone";
            isValid = false;
        }
        // Validation du numéro de CNI
        if (!data.numero_cni) {
            errors.numero_cni = "error_cni";
            isValid = false;
        } else if (data.numero_cni.length < 9) {
            errors.numero_cni = "error_taille_cni";
            isValid = false;
        }

        // Validation des documents
        if (data.documents_base64[0] === "" || data.documents_base64[1] === "" || data.documents_base64[2] === "" || data.documents_base64[3] === "") {
            errors.documents_base64 = "error_document";
            isValid = false;
        } else if (data.documents_base64.length > 4) {
            errors.documents_base64 = "error_taille_documenet";
            isValid = false;
        }

        // Validation de marque voiture
        if (!data.vehicle_name || data.vehicle_name.trim().length === 0) {
            errors.vehicle_name = "error_name_vehicule";
            isValid = false;
        }

        // Validation de l'experience
        if (!data.vehicle_model || data.vehicle_model.trim().length === 0) {
            errors.vehicle_model = "error_model";
            isValid = false;
        }

        // Validation des documents
        if (data.vehicle_papers_base64[0] === "" || data.vehicle_images_base64[1] === "") {
            errors.vehicle_papers_base64 = "error_paper";
            isValid = false;
        }

        // Validation de l'experience
        if (!data.vehicle_condition || data.vehicle_condition.trim().length === 0) {
            errors.vehicle_condition = "error_condition";
            isValid = false;
        }

        // Validation de l'experience
        if (!data.numero_immatriculation || data.numero_immatriculation.trim().length === 0) {
            errors.numero_immatriculation = "error_immatriculation";
            isValid = false;
        }

        // Validation de l'experience
        if (!data.vehicle_description || data.vehicle_description.trim().length === 0) {
            errors.vehicle_description = "error_description";
            isValid = false;
        }

        // Validation de l'experience
        if (data.vehicle_images_base64.length === 0) {
            errors.vehicle_images_base64 = "error_image_vehicule";
            isValid = false;
        }
        return {
            isValid,
            errors
        };
    }
    const nextStep = () => {
        console.log("zone", zones.map(zone => zone.arrondissement),)
        const validation = validateUserData1(transporteur)
        if (!validation.isValid) {
            console.log(validation.errors)
            setErrors(validation.errors)
            if (validation.errors?.nom_complet) {
                toast.error(t(validation.errors?.nom_complet || ""))
                return
            }
            if (validation.errors?.phone_number) {
                toast.error(t(validation.errors?.phone_number || ""))
                return
            }
            if (validation.errors?.region) {
                toast.error(t(validation.errors?.region || ""))
                return
            }
            if (validation.errors?.departement) {
                toast.error(t(validation.errors?.departement || ""))
                return
            }
            if (validation.errors?.city) {
                toast.error(t(validation.errors?.city || ""))
                return
            }
            if (validation.errors?.address) {
                toast.error(t(validation.errors?.address || ""))
                return
            }
            if (validation.errors?.numero_cni) {
                toast.error(t(validation.errors?.numero_cni || ""))
                return
            }
            return
        }
        setStep(2)
    }
    const handleSubmit = async () => {
        const validation = validateUserData2(transporteur)
        if (!validation.isValid) {
            console.log(validation.errors)
            setErrors(validation.errors)
            if (validation.errors?.numero_cni) {
                toast.error(t(validation.errors?.numero_cni || ""))
                return
            }
            if (validation.errors?.documents_base64) {
                toast.error(t(validation.errors?.documents_base64 || ""))
                return
            }
            if (validation.errors?.vehicle_images_base64) {
                toast.error(t(validation.errors?.vehicle_images_base64 || ""))
                return
            }
            if (validation.errors?.vehicle_name) {
                toast.error(t(validation.errors?.vehicle_name || ""))
                return
            }
            if (validation.errors?.vehicle_model) {
                toast.error(t(validation.errors?.vehicle_model || ""))
                return
            }
            if (validation.errors?.vehicle_papers_base64) {
                toast.error(t(validation.errors?.vehicle_papers_base64 || ""))
                return
            }


            if (validation.errors?.vehicle_condition) {
                toast.error(t(validation.errors?.vehicle_condition || ""))
                return
            }
            if (validation.errors?.numero_immatriculation) {
                toast.error(t(validation.errors?.numero_immatriculation || ""))
                return
            }
            if (validation.errors?.vehicle_description) {
                toast.error(t(validation.errors?.vehicle_description || ""))
                return
            }
            return
        }
        setLoad(true)
        console.log("zones", transporteur)
        try {
            await axios.post(createAccountTransporteur, {
                ...transporteur,
                zones_couvertures: zones.map(zone => zone.arrondissement),
                phone_number: transporteur.phone_number.includes("+237") ? transporteur.phone_number : "+237" + transporteur.phone_number,
                documents_base64: [base64Image[0], base64Image[1], base64Image[2], base64Image[3]],
                images_base64: imgCar,
                vehicle_papers_base64: [base64Image[5], base64Image[6]],
                vehicle_images_base64: imgCar,
            })
            toast.success(t("transporteur_cree"))
            setTransporteur({
                nom_complet: "",
                phone_number: "",
                region: "",
                departement: "",
                city: "",
                address: "",
                experience: "",
                zones_couvertures: [],
                numero_cni: "",
                documents_base64: [],
                images_base64: [],
                vehicle_name: "",
                vehicle_model: "",
                vehicle_condition: "",
                vehicle_description: "",
                numero_immatriculation: "",
                vehicle_images_base64: [],
                vehicle_papers_base64: [],
            })
            setDepartements([])
            setDepartements2([])
            setArrondissements2([])
            setArrondissements([])
            setZone([
                {
                    id: currentDate.getTime(),
                    region_id: "",
                    departement_id: "",
                    arrondissement_id: "",
                    region: "",
                    departement: "",
                    arrondissement: ""
                }
            ])
            setBase64Image(["", "", "", "", "", "", ""])
            setStep(3)
        } catch (error: any) {
            console.log(error)
            if (error.response) {
                toast.error(i18n.language ? error.response?.data.message : error.response?.data.messageE)
            }

        } finally {
            setLoad(false)
        }
    }
    return (
        <div className='flex flex-col w-full py-5 justify-center'>
            <div className="flex flex-row py-5 items-center justify-start w-full ml-10">

                <Breadcrumb />
            </div>
            <div className='mb-10'>
                <h1 className='text-2xl text-center font-bold'>{t("devenir_transporteur")}</h1>
                <h2 className=' text-center font-normal'>{t("rejoigne_equipe")}</h2>
            </div>
            {step === 1 && <div className='mx-auto w-[60%] mb-4 flex items-center '>
                <span onClick={() => setStep(1)} className='bg-green-600 cursor-pointer flex items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>1</span>
                <span className='h-[10px] w-[40%] shadow-sm bg-gray-300'></span>
                <span onClick={nextStep} className='bg-gray-600 flex items-center justify-center cursor-pointer  rounded-full text-white font-bold h-[50px] w-[50px]'>2</span>
                <span className='h-[10px] w-[40%] shadow-sm bg-gray-300'></span>
                <span className='bg-gray-600 flex items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>{t("fin")}</span>
            </div>}
            {step === 2 && <div className='mx-auto w-[60%] mb-4 flex items-center '>
                <span onClick={() => setStep(1)} className='bg-green-600 cursor-pointer flex items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>1</span>
                <span className='h-[10px]  w-[40%] shadow-sm bg-green-300'></span>
                <span onClick={() => setStep(2)} className='bg-green-600 flex cursor-pointer items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>2</span>
                <span className='h-[10px] w-[40%] shadow-sm bg-gray-300'></span>
                <span className='bg-gray-600 flex items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>{t("fin")}</span>
            </div>}
            {step === 3 && <div className='mx-auto w-[60%] mb-4 flex items-center '>
                <span onClick={() => setStep(1)} className='bg-green-600 cursor-pointer flex items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>1</span>
                <span className='h-[10px]  w-[40%] shadow-sm bg-green-300'></span>
                <span onClick={() => setStep(2)} className='bg-green-600 flex cursor-pointer items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>2</span>
                <span className='h-[10px] w-[40%] shadow-sm bg-green-300'></span>
                <span className='bg-green-600 flex items-center justify-center  rounded-full text-white font-bold h-[50px] w-[50px]'>{t("fin")}</span>
            </div>}
            {step === 1 && <div className='flex shadow-xl shadow-slate-800 flex-col justify-center md:justify-between p-5 mx-auto w-[80%] border '>
                <div className='flex flex-col md:flex-row justify-between gap-5'>
                    <div className=' w-[80%] md:w-[40%]'>
                        <div className='flex flex-col gap-2'>
                            <label htmlFor="nom">{t("nom")}</label>
                            <input value={transporteur.nom_complet} onChange={(e) => handleChangeTransporteur("nom_complet", e)} type="text" className={` ${errors?.nom_complet ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("nom_placeholder")} />
                            <p className='text-red-500 text-[10px] font-sans'>{t(errors?.nom_complet || "")}</p>
                        </div>
                        <div className='mt-4 flex flex-col gap-2'>
                            <label htmlFor="phone">{t("telephone")}</label>
                            <input value={transporteur.phone_number} onChange={(e) => handleChangeTransporteur("phone_number", e)} type="text" className={` ${errors?.phone_number ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("phone_placeholder")} />
                            <p className='text-red-500 text-[10px] font-sans'>{t(errors?.phone_number || "")}</p>
                        </div>
                        <h2 className='font-normal mt-10'>{t("lieu_residence")}</h2>
                        <div className='border-2 p-5 rounded-sm'>
                            {loading ? <div>{t("chargement")}...</div> :
                                <div className='mt-4 flex flex-col gap-2'>
                                    <select value={transporteur.region} onChange={(e) => {
                                        const value: any = regions.find((item: any) => item.region_name === e.target.value)
                                        handleRegionChange(value.region_id)
                                        handleChangeTransporteur("region", e)
                                    }} className={` ${errors?.region ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} name="region" id="region">
                                        <option value="">{t("select_region")}</option>
                                        {regions.map((region: any) => (
                                            <option key={region.id} value={region.region_name}>{i18n.language === "fr" ? region.region_name : region.region_name_en}</option>
                                        ))}
                                    </select>
                                    <p className='text-red-500 text-[10px] font-sans'>{t(errors?.region || "")}</p>
                                </div>}
                            <div className='mt-4 flex flex-col gap-2'>
                                <select onChange={(e) => {
                                    const value: any = departements.find((item: any) => item.departement_name === e.target.value)
                                    handleDepartmentChange(value.departement_id)
                                    handleChangeTransporteur("departement", e)
                                }} className={` ${errors?.departement ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} name="departement" id="departement">
                                    <option value="">{t("select_departement")}</option>
                                    {departements.map((departement: any) => (
                                        <option key={departement.id} value={departement.departement_name}>{i18n.language === "fr" ? departement.departement_name : departement.departement_name_en}</option>
                                    ))}
                                </select>
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.departement || "")}</p>
                            </div>
                            <div className='mt-4 flex flex-col gap-2'>
                                <select onChange={(e) => handleChangeTransporteur("city", e)} className={` ${errors?.city ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} name="arrondissement" id="arrondissement">
                                    <option value="">{t("select_arrondissement")}</option>
                                    {arrondissements.map((arrondissement: any) => (
                                        <option key={arrondissement.id} value={arrondissement.arrondissement_name}>{i18n.language === "fr" ? arrondissement.arrondissement_name : arrondissement.arrondissement_name_en}</option>
                                    ))}
                                </select>
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.city || "")}</p>
                                {/* <label htmlFor="nom">{t("arrondissement")}</label>
                            <input type="text" className='border-2 p-2 rounded-sm' placeholder={t("phone_placeholder")} /> */}
                            </div>
                            <div className='mt-4 flex flex-col gap-2'>
                                <label htmlFor="Address">{t("address")}</label>
                                <input value={transporteur.address} onChange={(e) => handleChangeTransporteur("address", e)} type="text" className={` ${errors?.address ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("address_placeholder")} />
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.address || "")}</p>
                            </div>
                        </div>
                    </div>
                    <div className=' w-[80%] md:w-[40%]'>
                        <div className='mt-4 flex flex-col gap-2'>
                            <label htmlFor="Anne d'experience">{t("anne_experience")}</label>
                            <input value={transporteur.experience} onChange={(e) => handleChangeTransporteur("experience", e)} type="text" className={` ${errors?.experience ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("anne_experience_placeholder")} />
                            <p className='text-red-500 text-[10px] font-sans'>{t(errors?.experience || "")}</p>
                        </div>

                        <div className='mt-4 flex flex-row items-center justify-between'>
                            <h2 className='font-normal'>{t("zone_couverture")}</h2>
                            <button onClick={newZone}>
                                <CirclePlus color='#CE181E' size={20} />
                            </button>

                        </div>
                        {zones.map((zone: any) => {
                            return (
                                <div className={` ${errors?.zones_couvertures ? "border-red-600" : "border-gray-200"} border-2 p-5 mt-4 rounded-sm`}>
                                    {loading ? <div>{t("chargement")}...</div> :
                                        <div className='mt-4 flex flex-col gap-2'>
                                            <select value={zone.region} onChange={(e) => {
                                                const value: any = regions2.find((item: any) => item.region_name === e.target.value)
                                                handleRegionChange2(Number(value.region_id))
                                                handleChange(zone.id, e, value ? value.region_name : '')
                                            }} className='border-2 p-2 rounded-sm' name="region" id="region">
                                                <option value="">{t("select_region")}</option>
                                                {regions2.map((region: any) => (
                                                    <option key={region.id} value={region.region_name}>{i18n.language === "fr" ? region.region_name : region.region_name_en}</option>
                                                ))}
                                            </select>
                                        </div>}
                                    <div className='mt-4 flex flex-col gap-2'>
                                        <select value={zone.departement} onChange={(e) => {
                                            const value: any = departements2.find((item: any) => item.departement_name === e.target.value)
                                            handleDepartmentChange2(value.departement_id)
                                            // const value:any = departements2.find((item: any) => item.departement_id === Number(e.target.value))
                                            handleChange(zone.id, e, value ? value.departement_name : "")
                                        }} className='border-2 p-2 rounded-sm' name="departement" id="departement">
                                            <option value="">{t("select_departement")}</option>
                                            {departements2.map((departement: any) => (
                                                <option key={departement.id} value={departement.departement_name}>{i18n.language === "fr" ? departement.departement_name : departement.departement_name_en}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='mt-4 flex flex-col gap-2'>
                                        <select value={zone.arrondissement} onChange={(e) => {
                                            const tmpZone = [...zones_couvertures]
                                            tmpZone.push(e.target.value)
                                            setZones_couvertures(tmpZone)
                                            handleChange(zone.id, e, e.target.value)
                                        }} className='border-2 p-2 rounded-sm' name="arrondissement" id="arrondissement">
                                            <option value="">{t("select_arrondissement")}</option>
                                            {arrondissements2.map((arrondissement: any) => (
                                                <option key={arrondissement.id} value={arrondissement.arrondissement_name}>{i18n.language === "fr" ? arrondissement.arrondissement_name : arrondissement.arrondissement_name_en}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <p className='text-red-500 text-[10px] font-sans'>{t(errors?.zones_couvertures || "")}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>

                <button onClick={nextStep} className='bg-[#15803D] text-white p-3 rounded-3xl mt-10 w-[70%] mx-auto hover:bg-[#15803D]/80 transition-all duration-300 ease-in-out'>
                    {t("next")}
                </button>
            </div>}
            {step === 2 && <div className='flex shadow-xl shadow-slate-800 flex-col justify-center md:justify-between p-5 mx-auto w-[80%] border '>
                <div className='flex flex-col  justify-between gap-5'>
                    <div className=' w-[80%]'>
                        <div>{t("doc_justificatif")}</div>
                        <div className={`  ${errors?.documents_base64 ? "border-red-600" : "border-gray-200"} border-2 p-4`}>
                            <div className='flex flex-col gap-2'>
                                <label htmlFor="Cni">{t("num_cni")}</label>
                                <input value={transporteur.numero_cni} type="text" onChange={(e) => handleChangeTransporteur("numero_cni", e)} className={`  ${errors?.numero_cni ? "border-red-600" : "border-gray-200"} border-2 p-2 rounded-sm`} placeholder={t("num_cni")} />
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.numero_cni || "")}</p>
                                <div className='flex mt-3 justify-between'>
                                    <button onClick={() => handleButtonClick(0)} className=' w-[25%] flex-col flex items-center justify-center'>
                                        <input
                                            type="file"
                                            name='image'
                                            accept='image/*'
                                            ref={fileInputRef}
                                            onChange={(e) => handleFileChange(0, e)}
                                            className="hidden"
                                        />
                                        {base64Image[0] === "" ? <img src="/assets/Vector.png" alt="vector" /> :
                                            <img className='w-[50px] h-[50px]' src={base64Image[0]} alt="vector" />}
                                        <p className='text-[10px] text-center mt-3 '>{t("cni_recto")}</p>
                                    </button>
                                    <button onClick={() => handleButtonClick(1)} className=' w-[25%] flex-col flex items-center justify-center'>
                                        <input
                                            type="file"
                                            name='image'
                                            accept='image/*'
                                            onChange={(e) => handleFileChange(1, e)}
                                            ref={fileInputRef2}
                                            className="hidden"
                                        />
                                        {base64Image[1] === "" ? <img src="/assets/Vector.png" alt="vector" /> :
                                            <img className='w-[50px] h-[50px]' src={base64Image[1]} alt="vector" />}
                                        <p className='text-[10px] text-center mt-3'>{t("cni_verso")}</p>
                                    </button>
                                    <button onClick={() => handleButtonClick(2)} className=' w-[25%] flex-col flex items-center justify-center'>
                                        {base64Image[2] === "" ? <img src="/assets/Vector.png" alt="vector" /> :
                                            <img className='w-[50px] h-[50px]' src={base64Image[2]} alt="vector" />}
                                        <p className='text-[10px] text-center mt-3'>{t("permi_recto")}</p>
                                        <input
                                            type="file"
                                            name='image'
                                            accept='image/*'
                                            ref={fileInputRef3}
                                            onChange={(e) => handleFileChange(2, e)}
                                            className="hidden"
                                        />
                                    </button>
                                    <button onClick={() => handleButtonClick(3)} className=' w-[25%] flex-col flex items-center justify-center'>
                                        {base64Image[3] === "" ? <img src="/assets/Vector.png" alt="vector" /> :
                                            <img className='w-[50px] h-[50px]' src={base64Image[3]} alt="vector" />}
                                        <p className='text-[10px] text-center mt-3'>{t("permi_verso")}</p>
                                        <input
                                            type="file"
                                            name='image'
                                            accept='image/*'
                                            onChange={(e) => handleFileChange(3, e)}
                                            ref={fileInputRef4}
                                            className="hidden"
                                        />
                                    </button>
                                </div>
                            </div>
                            <p className='text-red-500 text-[10px] font-sans'>{t(errors?.documents_base64 || "")}</p>
                        </div>
                    </div>
                    <div className='w-[100%]'>
                        <div className='mt-5 flex flex-row items-center justify-between'>
                            {t("vehicule")}
                            {/* <button onClick={newVehicule}>
                                <CirclePlus color='#CE181E' size={20} />
                            </button> */}

                        </div>
                        <div className='border-2 mt-5 p-3'>
                            <div className='text-[12px] w-[25%] flex flex-col items-center justify-center text-[#5A5A5A]'>
                                {t("photos_vehicule")}
                                <button onClick={() => handleButtonClick(4)} className='w-[100%] flex items-center flex-wrap justify-center  h-[50px] rounded-[25px]'>
                                    {imgCar.length === 0 ? <img src="/assets/photo.png" alt="phot" /> :
                                        imgCar.map((img) => (
                                            <img className='w-[30px] rounded-2xl flex-wrap m-1 h-[30px]' src={img} alt="vector" />))}

                                    <input
                                        type="file"
                                        name='image'
                                        ref={fileInputRef5}
                                        accept='image/*'
                                        onChange={(e) => handleImageCar(e)}
                                        className="hidden"
                                    />
                                </button>
                                <p className='text-red-500 text-[10px] font-sans'>{t(errors?.vehicle_images_base64 || "")}</p>
                            </div>
                            <div className='flex w-[100%] mt-5 flex-row justify-between'>
                                <div className=' flex flex-col gap-5 w-[40%]'>
                                    <div>
                                        <div className='text-[#5A5A5A]'>{t("nom_vehicule")}</div>
                                        <input value={transporteur.vehicle_name} name='name' onChange={(e) => handleChangeTransporteur("vehicle_name", e)} type="text" className={` ${errors?.vehicle_name ? "border-red-600" : "border-gray-200"} border-2 p-2 w-[100%] rounded-sm`} placeholder={t("nom")} />
                                        <p className='text-red-500 text-[10px] font-sans'>{t(errors?.vehicle_name || "")}</p>
                                    </div>
                                    <div>
                                        <div className='text-[#5A5A5A]'>{t("modele")}</div>
                                        <input value={transporteur.vehicle_model} type="text" name='modele' onChange={(e) => handleChangeTransporteur("vehicle_model", e)} className={` ${errors?.vehicle_model ? "border-red-600" : "border-gray-200"} border-2 p-2 w-[100%] rounded-sm`} placeholder={t("model_placeholder")} />
                                        <p className='text-red-500 text-[10px] font-sans'>{t(errors?.vehicle_model || "")}</p>
                                    </div>
                                    <div>
                                        <div className='text-[#5A5A5A]'>{t("papier_vehicule")}</div>
                                        <div className={` ${errors?.vehicle_papers_base64 ? "border-red-600" : "border-gray-200"} border-2 flex flex-col justify-between md:flex-row p-2 w-[100%] rounded-sm`}>
                                            <button onClick={() => handleButtonClick(5)} className='flex flex-col items-center justify-center'>
                                                {base64Image[5] === "" ? <img className='w-[40px] h-[40px]' src="/assets/Vector.png" alt="vector" /> :
                                                    <img className='w-[40px] h-[40px]' src={base64Image[5]} alt="vector" />}
                                                <p>{t("visite_tech")}</p>
                                                <input
                                                    type="file"
                                                    name='vehicle_papers_base64'
                                                    accept='image/*'
                                                    ref={fileInputRef6}
                                                    onChange={(e) => handleFileChange(5, e)}
                                                    className="hidden"
                                                />
                                            </button>
                                            <button onClick={() => handleButtonClick(6)} className='flex flex-col items-center justify-center' >
                                                {base64Image[6] === "" ? <img className='w-[40px] h-[40px]' src="/assets/Vector.png" alt="vector" /> :
                                                    <img className='w-[40px] h-[40px]' src={base64Image[6]} alt="vector" />}
                                                <p>{t("assurance")}</p>
                                                <input
                                                    type="file"
                                                    name='vehicle_papers_base64'
                                                    accept='image/*'
                                                    ref={fileInputRef7}
                                                    onChange={(e) => handleFileChange(6, e)}
                                                    className="hidden"
                                                />
                                            </button>
                                        </div>
                                        <p className='text-red-500 text-[10px] font-sans'>{t(errors?.vehicle_papers_base64 || "")}</p>
                                    </div>

                                </div>
                                <div className=' flex flex-col gap-5 w-[40%]'>
                                    <div>
                                        <div className='text-[#5A5A5A]'>{t("etat_vehicule")}</div>
                                        <select value={transporteur.vehicle_condition} onChange={(e) => {
                                            handleChangeTransporteur("vehicle_condition", e)
                                        }} className={` ${errors?.vehicle_condition ? "border-red-600" : "border-gray-200"} w-[100%] border-2 p-2 rounded-sm`} name="etat" id="region">
                                            <option value="">{t("etat_vehicule")}</option>
                                            <option value={"neuf"}>{t("neuf")}</option>
                                            <option value={"vieux"}>{t("vieux")}</option>

                                        </select>
                                        {/* <input type="text" name='etat' onChange={(e) => handleChangeTransporteur("vehicle_condition", e)} className={`${errors?.vehicle_condition ? "border-red-600" : "border-gray-200"}  border-2 p-2 w-[100%] rounded-sm`} placeholder={t("etat")} /> */}
                                        <p className='text-red-500 text-[10px] font-sans'>{t(errors?.vehicle_condition || "")}</p>
                                    </div>
                                    <div>
                                        <div className='text-[#5A5A5A]'>{t("immatriculation")}</div>
                                        <input value={transporteur.numero_immatriculation} type="text" name='immatriculaltion' onChange={(e) => handleChangeTransporteur("numero_immatriculation", e)} className={` ${errors?.numero_immatriculation ? "border-red-600" : "border-gray-200"} border-2 p-2 w-[100%] rounded-sm`} placeholder={t("immatriculation")} />
                                        <p className='text-red-500 text-[10px] font-sans'>{t(errors?.numero_immatriculation || "")}</p>
                                    </div>
                                    <div>
                                        <div className='text-[#5A5A5A]'>{t("description")}</div>
                                        <textarea value={transporteur.vehicle_description} onChange={(e) => handleChangeTransporteur("vehicle_description", e)} className={` ${errors?.vehicle_description ? "border-red-600" : "border-gray-200"} border-2 p-2 w-[100%] rounded-sm`} placeholder={t("placeholder_description")} />
                                        <p className='text-red-500 text-[10px] font-sans'>{t(errors?.vehicle_description || "")}</p>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <button disabled={load} onClick={() => handleSubmit()} className='bg-[#15803D] text-white p-3 rounded-3xl mt-10 w-[70%] mx-auto hover:bg-[#15803D]/80 transition-all duration-300 ease-in-out'>
                    {load ? <div className='w-[100%] flex items-center justify-center' ><Loader2 /></div> : t("envoyer_demande")}
                </button>
            </div>}
            {step === 3 && <div className='flex shadow-xl shadow-slate-800 flex-col justify-center md:justify-between p-5 mx-auto w-[80%] border '>
                <div className='flex flex-col h-[60vh] items-center justify-center gap-5'>

                    <CircleCheck size={200} color='#16a34a' />
                </div>
            </div>}
        </div>
    )
}

export default Add_transporteur